import Vue from 'vue';
import { convertOdds } from '@/views/sports/components/bet-slip/bet-slip-utils';

export function updateBetLineOdds(oldOddItem, point, odd, selectedOddType, oddType) {
  if (!odd) {
    Vue.set(oldOddItem, 'lock_odd_area', true);
    return;
  }

  var isMoneyLine = oddType === 'moneyLine';
  var isTotal = oddType === 'total';
  var isSpread = oddType === 'spread';
  var oldVisualPoint = oldOddItem.point;
  var oldVisualOdd = oldOddItem.odd;
  var visualOdd = convertOdds(odd, selectedOddType);
  var visualPoint = formatSpread(point);

  if (isMoneyLine) {
    if (oldVisualOdd != visualOdd)
      Vue.set(oldOddItem, 'odd', visualOdd);
  }

  if (isSpread || isTotal) {
    if (oldVisualPoint != visualPoint) {
      Vue.set(oldOddItem, 'point', visualPoint);
    }
    if (oldVisualOdd != visualOdd)
      Vue.set(oldOddItem, 'odd', visualOdd);
  }

  Vue.set(oldOddItem, 'lock_odd_area', false);
  return;
}

export function updateBetLineOutcome(oldOddItem, point, odd, selectedOddType, oddType, newItem, oldMarketItem, langId, isProp) {
  if (!odd) {
    Vue.set(oldOddItem, 'lock_odd_area', true);
    return;
  }
  var visualOdd = convertOdds(odd, selectedOddType);
  var outcomeName = '';
  if (!langId) outcomeName = newItem.onm;
  else if (langId == 0) outcomeName = newItem.onm;
  else if (langId == 1) outcomeName = newItem.onm_es;
  else if (langId == 6) outcomeName = newItem.onm_pt;
  else outcomeName = newItem.onm;

  Vue.set(oldOddItem, 'id', newItem.oid);
  Vue.set(oldOddItem, 'active', newItem.os);
  Vue.set(oldOddItem, 'point', point);
  Vue.set(oldOddItem, 'outcomeDescription', outcomeName);
  Vue.set(oldOddItem, 'active', newItem.os ? 1 : 0);
  if (oddType == 'spread') {
    Vue.set(oldOddItem, 'specifierPoint', point);
    if (!isProp)
      Vue.set(oldMarketItem, 'SpecifierPoint', point);
  }
  Vue.set(oldOddItem, 'odd', visualOdd);
  Vue.set(oldOddItem, 'lock_odd_area', false);
  return;
}

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function overOrUnder(id) {
  if (id) {
    var arrId = id.split('_');
    if (arrId[2] == 'to') {
      if (arrId[1] % 2 == 0) {
        return 'U ';
      } else {
        return 'O ';
      }
    }
  }
  return '';
}

export function isOver(id) {
  if (id) {
    var arrId = id.split('_');
    if (arrId[2] == 'to') {
      if (arrId[1] % 2 == 0) {
        return false;
      } else {
        return true;
      }
    }
  }
  return false;
}

export function formatSpread(num) {
  if (num == '') return '';

  num = Math.abs(num);
  let entero = Math.floor(num);
  let decimal = num - entero;
  if (decimal == 0.5 && entero == 0) {
    return '&frac12;';
  }
  if (decimal == 0.5) {
    return entero + '&frac12;';
  }
  if (entero == 0 && decimal == 0) {
    return '0.0';
  }
  return entero;
}

export function getSign(num) {
  if (num > 0) {
    return '+';
  } else {
    return '-';
  }
}
